/**
 * Copyright © 2022-2023 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */

import React, { useContext } from 'react'
import {
  PageTitle,
  FullScreenLayout,
  NavigationTabs,
} from '@dai/web-components'
import GeographicHierarchyContainer from 'stores/containers/hierarchy-management/GeographicHierarchy.container'
import StoreManagementContainer from 'stores/containers/store-management/StoreManagement.container'
import { Switch } from 'react-router-dom'
import ProtectedRoute from 'routes/ProtectedRoute'
import UserContext from 'context/UserContext'

const StoresContainer: React.FC = () => {
  const { user } = useContext(UserContext)
  return (
    <>
      <FullScreenLayout
        header={
          <PageTitle
            title="Stores"
            RightComponent={
              <NavigationTabs<'management' | 'hierarchy'>
                routeBase={'stores'}
                tabs={[
                  {
                    label: 'Management',
                    ext: 'management',
                  },
                  ...(user?.isSuperuser
                    ? [
                        {
                          label: 'Hierarchy',
                          ext: 'hierarchy' as 'hierarchy',
                        },
                      ]
                    : []),
                ]}
              />
            }
          />
        }
        bodyStyle={{ p: 0 }}
        body={
          <Switch>
            <ProtectedRoute path={'/stores/management'}>
              <StoreManagementContainer />
            </ProtectedRoute>
            <ProtectedRoute path={'/stores/hierarchy'}>
              <GeographicHierarchyContainer />
            </ProtectedRoute>
          </Switch>
        }
      />
    </>
  )
}

export default StoresContainer
